// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/get_user_response.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { User } from "./user_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_user } from "./user_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/get_user_response.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_get_user_response: GenFile = /*@__PURE__*/
  fileDesc("Cj9xdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvZ2V0X3VzZXJfcmVzcG9uc2UucHJvdG8SJ3F1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MSJcCg9HZXRVc2VyUmVzcG9uc2USQAoEdXNlchgBIAEoCzItLnF1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MS5Vc2VySACIAQFCBwoFX3VzZXJiBnByb3RvMw", [file_quanterix_simoa_one_analysis_app_api_v1_user]);

/**
 * Rpc response containing user record
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.GetUserResponse
 */
export type GetUserResponse = Message<"quanterix.simoa_one.analysis_app_api.v1.GetUserResponse"> & {
  /**
   * User record
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.GetUserResponse.
 * Use `create(GetUserResponseSchema)` to create a new message.
 */
export const GetUserResponseSchema: GenMessage<GetUserResponse> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_get_user_response, 0);

